import ApiService from "./api.service";

const PointService = {
  async sharePoints(data) {
    try {
      return await ApiService.post("share-points", data);
    } catch (error) {
      return error.response;
    }
  },
};

export { PointService };
